import { Injectable } from '@angular/core';
import { LocalStorageConstants } from './LocalStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  NumberToWords(amount: number): string {
    const singleDigits = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const twoDigits = ["", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tensMultiple = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const placeValues = ["", "Thousand", "Lakh", "Crore"];

    if (amount === 0) return "Zero Rupees";

    let num = Math.floor(amount);
    const paise = Math.round((amount - num) * 100);
    let words = "";

    const getTwoDigitWord = (n: number): string => {
      if (n < 10) return singleDigits[n];
      if (n < 20) return twoDigits[n - 9];
      return tensMultiple[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + singleDigits[n % 10] : "");
    };

    let i = 0;
    while (num > 0) {
      let divider = i === 0 ? 1000 : 100;
      let currentNumber = num % divider;
      num = Math.floor(num / divider);

      if (currentNumber > 0) {
        let part = "";
        if (currentNumber < 100) {
          part = getTwoDigitWord(currentNumber);
        } else {
          part = singleDigits[Math.floor(currentNumber / 100)] + " Hundred ";
          part += getTwoDigitWord(currentNumber % 100);
        }
        words = part + (placeValues[i] ? " " + placeValues[i] + " " : " ") + words;
      }
      i++;
    }

    //words = words.trim() + " Rupees";
    words = words.trim();

    if (paise > 0) {
      words += " and " + getTwoDigitWord(paise) + " Paise";
    }

    return words + " Only";
  }

  // If jwt_decode is not available as a module, define it here (example implementation)
  jwt_decode(token: string | null): any {
    if (!token) return {};
    try {
      // Example: decode JWT token payload
      const payload = token.split('.')[1];
      return JSON.parse(atob(payload));
    } catch {
      return {};
    }
  }

  GetMasterDataByKey(key: string): any {
    const masterData = JSON.parse(localStorage.getItem(LocalStorageConstants.MASTER_DATA));
    var masterDetails = masterData.filter(function (d) {
      return d.master_Code == key;
    });
if(masterDetails.length==0)
    return null;

return masterDetails[0].master_Description;

  }

   GetInvoiceConfiguration()
   {
     return {
      invoiceAddress: this.GetMasterDataByKey('InvoiceAddress') || 'not configured',
      invoiceEmail: this.GetMasterDataByKey('InvoiceEmail') || 'not configured',
      invoiceContactNo: this.GetMasterDataByKey('InvoiceContactNo') ||  'not configured',
      invoiceDeclaration: this.GetMasterDataByKey('InvoiceDeclaration') ||  'not configured',
      invoicePaymentTerm: this.GetMasterDataByKey('InvoicePaymentTerm') ||  'not configured',
      invoiceBankAcNo: this.GetMasterDataByKey('InvoiceBankAcNo') ||  'not configured',
      invoiceBankIFSC: this.GetMasterDataByKey('InvoiceBankIFSC') ||  'not configured',
      invoiceBankBranch: this.GetMasterDataByKey('InvoiceBankBranch') ||  'not configured',
      invoiceBankGSTNo: this.GetMasterDataByKey('InvoiceBankGSTNo') ||  'not configured',
      invoiceBankName: this.GetMasterDataByKey('InvoiceBankName') ||  'not configured',
      clientLogoUrl: this.GetMasterDataByKey('ClientLogoUrl') ||  'assets/images/logo/logo.png',
    };
   } 

   CheckUserAccess(pagename: string, userType: string): boolean {
    switch (pagename) {
      
      case 'customers':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Purchase ||
               userType == UserType.Sales ? true : false;

      case 'add-bill':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||  
               userType == UserType.Account ||
               userType == UserType.Sales ? true : false;

      case 'all-bills':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Sales ? true : false;

      case 'view-bill':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ||
               userType == UserType.Account ? true : false;

      case 'add-rent-repair-bill':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||  
               userType == UserType.Account ||
               userType == UserType.Sales ? true : false;

      case 'all-rent-repair-bills':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Sales ? true : false;

      case 'view-rent-repair-bill':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ||
               userType == UserType.Account ? true : false;

      case 'Add-Inventory':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Purchase ? true : false;

      case 'Inventories':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ? true : false;

      case 'Add-Used-Items':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ? true : false;

      case 'Used-Items':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ? true : false;

      case 'product-manufacturer':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Account ||
               userType == UserType.Purchase ? true : false;

      case 'vendors':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Account ||
               userType == UserType.Purchase ? true : false;
      
      case 'Stock':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Account ||
               userType == UserType.Purchase ? true : false;

      case 'add-purchase-request':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Purchase ? true : false;

      case 'all-purchase-requests':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Purchase ? true : false;

      case 'all-expenses':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ? true : false;

      case 'add-expense':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ? true : false;

      case 'all-stock':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ? true : false;

      case 'process-salary':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Hr ? true : false;

      case 'system-configuration':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ||
               userType == UserType.Account ||
               userType == UserType.Admin ? true : false;

      case 'clients':
        return userType == UserType.SuperAdmin ? true : false;

      case 'view-bill-report':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Sales ||
               userType == UserType.Purchase ||
               userType == UserType.Account ? true : false;

      case 'employees':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Hr ||
               userType == UserType.Account ? true : false;

      case 'product-inward':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Purchase ||
               userType == UserType.Sales ? true : false;

      case 'product-outwards':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Purchase ||
               userType == UserType.Sales ? true : false;

      case 'product-inwards':
        return userType == UserType.SuperAdmin ||
               userType == UserType.Admin ||
               userType == UserType.Account ||
               userType == UserType.Purchase ||
               userType == UserType.Sales ? true : false;

      default:
        return false;
    }
   }
}

enum UserType {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Account = 'Account',
  Hr = 'Hr',
  Sales = 'Sales',
  Purchase = 'Purchase'
}


